import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationConfig } from "resource-planner-model";
import {
  AppState,
  ReportFeedbackAction,
  REPORT_APP_FEEDBACK,
} from "../redux/AppTypes";
import { PERSIST_APPLICATION_CONFIG } from "../application-config/ApplicationConfigTypes";

export function useApplicationConfig(): ApplicationConfig {
  return useSelector((state: AppState) => state.applicationConfig.item);
}

export function usePersistApplicationConfig(): (
  item: ApplicationConfig
) => Promise<void> {
  const dispatch = useDispatch();
  return useCallback(
    (item: ApplicationConfig) => {
      const response = dispatch({
        type: PERSIST_APPLICATION_CONFIG,
        item,
      }) as any;
      return Promise.resolve(response).catch((error: any) => {
        const action: ReportFeedbackAction = {
          type: REPORT_APP_FEEDBACK,
          feedback: error.message || "error",
        };
        dispatch(action);
        throw error;
      });
    },
    [dispatch]
  );
}
